import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    next('/login')
  }
  else {
    next()
  }
}


const routes = [
  {
    path: '/' ,
    component: () => import("../view/userMainPage"),
    beforeEnter: ifAuthenticated,
    name:'mainPageUser',
  },
  {
    path: '/admin' ,
    component: () => import("../view/admin/admin"),
    beforeEnter: ifAuthenticated,
    name:'admin',
    children:[
      /*{
        path: '/' ,
        component: () => import("../view/admin/dashboard"),
        beforeEnter: ifAuthenticated,
        name:'dashboard',
      },*/
      {
        path: 'dashboard' ,
        component: () => import("../view/admin/dashboard"),
        beforeEnter: ifAuthenticated,
        name:'dashboard',
      },
      {
        path: 'users' ,
        component: () => import("../view/admin/users"),
        beforeEnter: ifAuthenticated,
        name:'users',
      },
      {
        path: 'projects' ,
        component: () => import("../view/admin/projects"),
        beforeEnter: ifAuthenticated,
        name:'projects',
      },
      {
        path: 'projects/project_id=:project_id' ,
        component: () => import("../view/admin/project"),
        beforeEnter: ifAuthenticated,
        name:'project',
      },
      {
        path: 'users/user_id=:user_id',
        component: () => import("../view/admin/user"),
        beforeEnter: ifAuthenticated,
        name:'user',
      },
      {
        path: 'costs',
        component: () => import("../view/admin/costs"),
        beforeEnter: ifAuthenticated,
        name:'costs',
      },
      {
        path: 'record',
        component: () => import("../view/userMainPage"),
        beforeEnter: ifAuthenticated,
        name:'record',
      },

    ]
  },
  {
    path:'/setting',
    component:()=>import('../view/setting/setting'),
    beforeEnter: ifAuthenticated,
    name:'setting'
  },
  {
    path:'/setting/integration',
    component:()=>import('../view/setting/components/integration'),
    beforeEnter: ifAuthenticated,
    name:'setting.integration'
  },
  {
    path: '/login',
    component: () => import("../view/login"),
    name:'login',
  },
  {
    path: '/forgot',
    component: () => import("../view/forgot"),
    name:'forgot'
  },
  {
    path: '/signup',
    component: () => import("../view/signup"),
    name:'signup'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
